import { createContext, Dispatch, SetStateAction } from 'react';

export const darkTheme = {
  base: '#000000',
  mantle: '#111111',
  crust: '#000000',
  text: '#EAEAEA',
  subtext0: '#999999',
  subtext1: '#888888',
  surface0: '#1B1B1B',
  surface1: '#2C2C2C',
  surface2: '#3A3A3A',
  overlay0: '#4A4A4A',
  overlay1: '#5A5A5A',
  overlay2: '#6A6A6A',
  blue: '#FFFFFF',
  lavender: '#FFFFFF',
  sapphire: '#FFFFFF',
  sky: '#FFFFFF',
  teal: '#FFFFFF',
  green: '#BDBDBD',
  yellow: '#888888',
  peach: '#FFFFFF',
  maroon: '#5A5A5A',
  red: '#FFFFFF',
  mauve: '#FFFFFF',
  pink: '#FFFFFF',
  flamingo: '#FFFFFF',
  rosewater: '#FFFFFF',
  glass: {
    background: 'rgba(20, 20, 20, 0.7)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(8px)',
  }
};

export const lightTheme = {
  base: '#FFFFFF',
  mantle: '#F9F9F9',
  crust: '#FFFFFF',
  text: '#111111',
  subtext0: '#666666',
  subtext1: '#888888',
  surface0: '#F1F1F1',
  surface1: '#EAEAEA',
  surface2: '#DEDEDE',
  overlay0: '#C8C8C8',
  overlay1: '#B1B1B1',
  overlay2: '#A0A0A0',
  blue: '#000000',
  lavender: '#000000',
  sapphire: '#000000',
  sky: '#000000',
  teal: '#000000',
  green: '#444444',
  yellow: '#888888',
  peach: '#000000',
  maroon: '#BDBDBD',
  red: '#000000',
  mauve: '#000000',
  pink: '#000000',
  flamingo: '#000000',
  rosewater: '#000000',
  glass: {
    background: 'rgba(250, 250, 250, 0.7)',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(8px)',
  }
};

export type ThemeType = typeof darkTheme;
export const ThemeContext = createContext<ThemeType>(darkTheme);
export const ThemeUpdateContext = createContext<Dispatch<SetStateAction<ThemeType>>>(() => {}); 
